import React, { useEffect, useState } from 'react';
import { Layers, Edit, Plus, RefreshCw, Trash2, Building2, Award, Briefcase } from 'lucide-react';
import http from '../api/http';
import { useAuth } from '../context/AuthContext';
import BlueHeader from '../components/BlueHeader';

const Departements = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('departements');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({});

  const fetchData = async () => {
    try {
      setLoading(true);
      console.log('[DEPARTEMENTS] fetchData - activeTab:', activeTab);
      let response;
      if (activeTab === 'departements') {
        response = await http.get('/api/departements');
      } else if (activeTab === 'business-units') {
        response = await http.get('/api/business-units');
      } else if (activeTab === 'grades') {
        response = await http.get('/api/grades');
      }
      console.log('[DEPARTEMENTS] Response:', response);
      setData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('[DEPARTEMENTS] Erreur:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const handleCreate = () => {
    setEditingItem(null);
    setFormData({});
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({ ...item });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const itemName = activeTab === 'departements' ? 'département' : activeTab === 'business-units' ? 'Business Unit' : 'grade';
    if (!window.confirm(`Êtes-vous sûr de vouloir supprimer ce ${itemName} ?`)) return;

    try {
      let endpoint;
      if (activeTab === 'departements') {
        endpoint = `/api/departements/${id}`;
      } else if (activeTab === 'business-units') {
        endpoint = `/api/business-units/${id}`;
      } else if (activeTab === 'grades') {
        endpoint = `/api/grades/${id}`;
      }
      await http.delete(endpoint);
      fetchData();
    } catch (error) {
      alert('Erreur lors de la suppression: ' + (error.response?.data?.error || 'Erreur inconnue'));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let endpoint;
      if (activeTab === 'departements') {
        endpoint = editingItem ? `/api/departements/${editingItem.iddepartement}` : '/api/departements';
      } else if (activeTab === 'business-units') {
        endpoint = editingItem ? `/api/business-units/${editingItem.idbusiness_unit}` : '/api/business-units';
      } else if (activeTab === 'grades') {
        endpoint = editingItem ? `/api/grades/${editingItem.idgrade}` : '/api/grades';
      }
      
      if (editingItem) {
        await http.put(endpoint, formData);
      } else {
        await http.post(endpoint, formData);
      }
      setShowModal(false);
      fetchData();
    } catch (error) {
      alert('Erreur: ' + (error.response?.data?.error || 'Erreur inconnue'));
    }
  };

  const renderForm = () => {
    if (activeTab === 'departements') {
      return (
        <div>
          <label className="mb-1.5 block text-sm font-medium text-night-blue">Libellé</label>
          <input
            type="text"
            className="input-field"
            value={formData.libelle_departement || ''}
            onChange={(e) => setFormData({ ...formData, libelle_departement: e.target.value })}
            required
          />
        </div>
      );
    } else if (activeTab === 'business-units') {
      return (
        <div className="space-y-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-night-blue">Code</label>
            <input
              type="text"
              className="input-field"
              value={formData.code || ''}
              onChange={(e) => setFormData({ ...formData, code: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-night-blue">Libellé</label>
            <input
              type="text"
              className="input-field"
              value={formData.libelle || ''}
              onChange={(e) => setFormData({ ...formData, libelle: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-night-blue">Description</label>
            <textarea
              className="input-field"
              value={formData.description || ''}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              rows={3}
            />
          </div>
        </div>
      );
    } else if (activeTab === 'grades') {
      return (
        <div className="space-y-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-night-blue">Code</label>
            <input
              type="text"
              className="input-field"
              value={formData.code || ''}
              onChange={(e) => setFormData({ ...formData, code: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-night-blue">Libellé</label>
            <input
              type="text"
              className="input-field"
              value={formData.libelle || ''}
              onChange={(e) => setFormData({ ...formData, libelle: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-night-blue">Niveau hiérarchique</label>
            <input
              type="number"
              className="input-field"
              value={formData.niveau || ''}
              onChange={(e) => setFormData({ ...formData, niveau: parseInt(e.target.value) || null })}
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-night-blue">Description</label>
            <textarea
              className="input-field"
              value={formData.description || ''}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              rows={3}
            />
          </div>
        </div>
      );
    }
  };

  const renderTable = () => {
    if (activeTab === 'departements') {
      return (
        <>
          <thead className="bg-gray-50 dark:bg-gray-900">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">ID</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Département</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Personnel</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            {data.map((item) => (
              <tr key={item.iddepartement} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">{item.iddepartement}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white font-medium">{item.libelle_departement}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <span className="inline-flex items-center rounded-full bg-blue-100 dark:bg-blue-900 px-2 py-0.5 text-xs font-medium text-blue-600 dark:text-blue-300">
                    {item.nombre_personnel || 0}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <div className="flex gap-2">
                    <button type="button" onClick={() => handleEdit(item)} className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
                      <Edit className="h-4 w-4" />
                    </button>
                    <button type="button" onClick={() => handleDelete(item.iddepartement)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300">
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </>
      );
    } else if (activeTab === 'business-units') {
      return (
        <>
          <thead className="bg-gray-50 dark:bg-gray-900">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Code</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Libellé</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Responsable</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            {data.map((item) => (
              <tr key={item.idbusiness_unit} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">{item.code}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white font-medium">{item.libelle}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                  {item.responsable_nom && item.responsable_prenom ? `${item.responsable_prenom} ${item.responsable_nom}` : '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <div className="flex gap-2">
                    <button type="button" onClick={() => handleEdit(item)} className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
                      <Edit className="h-4 w-4" />
                    </button>
                    <button type="button" onClick={() => handleDelete(item.idbusiness_unit)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300">
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </>
      );
    } else if (activeTab === 'grades') {
      return (
        <>
          <thead className="bg-gray-50 dark:bg-gray-900">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Code</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Libellé</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Niveau</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            {data.map((item) => (
              <tr key={item.idgrade} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">{item.code}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white font-medium">{item.libelle}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                  {item.niveau || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <div className="flex gap-2">
                    <button type="button" onClick={() => handleEdit(item)} className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
                      <Edit className="h-4 w-4" />
                    </button>
                    <button type="button" onClick={() => handleDelete(item.idgrade)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300">
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </>
      );
    }
  };

  const renderTabs = () => {
    const tabs = [
      { id: 'departements', label: 'Départements', icon: Layers },
      { id: 'business-units', label: 'Business Units', icon: Briefcase },
      { id: 'grades', label: 'Grades', icon: Award }
    ];

    return (
      <div className="border-b border-gray-200">
        <nav className="flex gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`pb-3 px-1 font-medium text-sm transition-colors ${
                activeTab === tab.id
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <div className="flex items-center gap-2">
                <tab.icon className="h-4 w-4" />
                {tab.label}
              </div>
            </button>
          ))}
        </nav>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <BlueHeader
        title="Organisation"
        subtitle="Gestion des départements, Business Units et Grades"
        icon={Building2}
        actions={[
          {
            label: 'Créer',
            icon: Plus,
            onClick: handleCreate,
            primary: true
          },
          {
            label: 'Actualiser',
            icon: RefreshCw,
            onClick: fetchData,
            primary: false
          }
        ]}
      />

      <div className="px-6 py-8 space-y-6">
        {renderTabs()}

        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          {loading ? (
          <div className="flex h-48 items-center justify-center text-sm text-gray-500 dark:text-gray-400">
            Chargement…
          </div>
        ) : data.length === 0 ? (
          <div className="px-4 py-16 text-center text-sm text-gray-500 dark:text-gray-400">
            Aucun {activeTab === 'departements' ? 'département' : activeTab === 'business-units' ? 'Business Unit' : 'grade'}.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              {renderTable()}
            </table>
          </div>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl border border-blue-100">
            <div className="mb-4 flex items-center justify-between border-b border-blue-100 pb-4">
              <h3 className="text-lg font-bold text-blue-900">
                {editingItem ? 'Modifier' : 'Créer'} {activeTab === 'departements' ? 'Département' : activeTab === 'business-units' ? 'Business Unit' : 'Grade'}
              </h3>
              <button type="button" onClick={() => setShowModal(false)} className="text-gray-500 hover:text-gray-900">✕</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="space-y-4">
                {renderForm()}
              </div>
              <div className="mt-6 flex justify-end gap-3 border-t border-blue-100 pt-4">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300">
                  Annuler
                </button>
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                  {editingItem ? 'Modifier' : 'Créer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default Departements;
